module.exports = __webpack_public_path__ + "svgs/used.7c22ac70.svg";